import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import StreamgraphChart from './components/StreamgraphChart'
import { Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import SourceLink from '../../component/chartLinkData'


interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      Viral load in wastewater - Covid-19 {season} (France){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The indicator is calculated based on the ratio between SARS-Cov2 viral
              concentration (expressed in cg/L and quantification based on gene E) and
              ammoniacal nitrogen concentration (expressed in mg of N/L). Resulting data
              is then smoothed using the LOESS regression method. Data is updated on a
              weekly basis. Source: SUM’Eau.
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  return (
    <>
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row '>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body '>
                <HeaderChart />
              </div>
              <Card.Body style={{ marginTop: '-3%' }} className='row '>
                <StreamgraphChart season={mainSeason} />
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source'>
                    <i>
                      Source:<a
                        className='fw-bold'
                        href='https://www.data.gouv.fr/fr/datasets/surveillance-du-sars-cov-2-dans-les-eaux-usees-sumeau/'
                      > SUM’Eau</a>
                    </i>{' '}
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>
              </Card.Body>
            </div>
          </Card>
          <Modal
            // size="xl"
            className="modal-xxl"
            show={showSeasonModal}
            onHide={() => setShowSeasonModal(false)}
            centered
          >
            <Modal.Header closeButton className='py-4'>
              <Modal.Title>
                <HeaderChart season={'2023-2024'} />
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <StreamgraphChart season={modalSeason} />
              <div className="d-flex justify-content-between align-items-center">
                <p className='card-text source'>
                  <i>
                    Source:<a
                      className='fw-bold'
                      href='https://www.data.gouv.fr/fr/datasets/surveillance-du-sars-cov-2-dans-les-eaux-usees-sumeau/'
                    > SUM’Eau</a>
                  </i>{' '}
                </p>
              </div>
            </Modal.Body>
          </Modal>
          {/* <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <h2 className='text-primary bold'> Viral Load in wastewater - Covid-19</h2>
                <p className='card-text p-2 bg-secondary rounded'>
                  Some quick example text to build on the card title and make up the bulk of the
                  card's content.
                </p>
              </div>
              <Card.Body className='row '>
                <FranceRegionsMap /> */}
          {/* <p className='card-text source'>
                  <img
                    className='mb-1'
                    style={{width: '12px'}}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                  <i>Source: SUM’EAU</i>
                </p> */}
          {/* </Card.Body> */}
          {/* </div> */}
          {/* </Card> */}
        </div>
      </div>
    </>
  )
}

const WasteWaterCovid = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export { WasteWaterCovid }
